var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"msg":"VueJS Panorama Viewer"}}),_c('Panorama',{staticClass:"pano",attrs:{"source":_vm.url2,"caption":_vm.caption}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }